<!--
  支付方式
  Lovi 2020-2-17
-->
<template>
  <div>
    <div class="column">
      <div class="title">
        <h3>{{ $t("common.selectPayment") }}</h3>
        <span
          v-if="showDiscount"
          class="text-blue"
          @click="discountFlag = true"
        >
          {{ $t("common.rechargeDiscount") }}
        </span>
      </div>
      <van-radio-group v-model="curPayType" @change="changeRadio">
        <van-radio
          :disabled="
            item.type == 3 && money > 0 && money > Number(userInfo.money_usable)
          "
          checked-color="#FE7800"
          :name="item.type"
          v-for="(item, index) in payList"
          :key="index"
        >
          <div class="logoImg"><img :src="httpUrl + item.icon" /></div>
          <span>{{ item.name }}</span>
          <template v-if="item.type == 3">
            <span
              class="text-gray"
              v-if="money > Number(userInfo.money_usable)"
            >
              {{ $t("common.insufficientAccountBalance") }}
            </span>
            <span v-else class="text-orange">
              {{ $t("common.balance") }}:{{ userInfo.money_usable }}P
            </span>
          </template>
          <span class="text-orange" v-if="item.exchange_rate_show != ''">
            {{ $t("common.rate") }}{{ item.exchange_rate_show }}
          </span>
        </van-radio>
      </van-radio-group>
    </div>

    <!-- 充值优惠 -->
    <discount :discountFlag.sync="discountFlag" :list="discountsList" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Discount from "./discount";
export default {
  props: {
    type: {
      type: Number,
      default: 0
    },
    flag: {
      type: Number,
      default: 0
    },
    money: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    showDiscount: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  components: {
    Discount
  },
  data() {
    return {
      payList: [], //支付列表
      curPayType: "",
      curPay: [], //当前支付数据
      discountFlag: false, // 充值优惠
      discountsList: []
    };
  },
  created() {
    if (this.showDiscount) {
      this.rechargeDiscount();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    changeRadio(type) {
      let vm = this;
      vm.curPayType = type;
      for (var i = 0; i < vm.payList.length; i++) {
        if (vm.payList[i].type == type) {
          vm.curPay = vm.payList[i];
          vm.$emit("getCurPay", vm.curPay);
        }
      }
      console.log("vm.curPay", vm.curPay);
    },
    _getPayType() {
      let vm = this;
      let params = {};
      vm.$post("/app/user/payType", params, { loading: true }).then(res => {
        console.log("payType", res);
        vm.payList = [];
        console.log("flag", vm.flag);
        console.log("type", vm.type);
        for (let key of res) {
       /*   if (key.type == 10) {
            key.name="支付宝";
          }*/
          if (vm.type == 1) {
            // 余额充值
            if (key.type != 3) {
                if(vm.enter=="pc") {
                  if(key.type!=1&&key.type!=2) {
                    vm.payList.push(key);
                  }
                }
                else if(vm.enter=="wechat") {
                  if(key.type!=2)
                  {
                    vm.payList.push(key);
                  }
                }
                else
                {
                  vm.payList.push(key);
                }

            }
          } else if (vm.type == 2) {
            debugger
            // 只有余额
            if (key.type == 3) {
              vm.payList.push(key);
            }
          } else {
            if (key.type != 7 && key.type != 8) {

                if(vm.enter=="pc") {
                  if(key.type!=1&&key.type!=2) {
                    vm.payList.push(key);
                  }
                  //G不要支付宝
                  if (vm.flag == 4 &&  key.type == 10) {
                    vm.payList.pop();
                  }

                  //电子钱包不要支付宝
                  if (vm.flag == 7 &&  key.type == 10) {
                    vm.payList.pop();

                  }
                }
                else if(vm.enter=="wechat") {
                  if(key.type!=2)
                  {
                    vm.payList.push(key);
                  }

                  //G不要支付宝
                  if (vm.flag == 4 && key.type == 10) {
                    vm.payList.pop();
                  }

                  //电子钱包不要支付宝
                  if (vm.flag == 7 &&  key.type == 10) {
                    vm.payList.pop();

                  }
                }
                else
                {
                  vm.payList.push(key);

                  //G不要支付宝
                  if (vm.flag == 4 && key.type == 2) {
                    vm.payList.pop();
                  }

                  //电子钱包不要支付宝
                  if (vm.flag == 7 && key.type == 2) {
                    vm.payList.pop();

                  }
                }

            }
          }

          //ios和wecaht支付宝h5
          if(vm.enter=="app"&&key.type==10&&vm.type != 2)
          {
            vm.payList.pop();
          }

        }
        // 默认数据
        vm.curPayType = vm.payList[0].type;
        vm.curPay = vm.payList[0];
        vm.$emit("getCurPay", vm.curPay);
        console.log("vm.payList", vm.payList);
        console.log("vm.curPay", vm.curPay);
      });
    },
    rechargeDiscount() {
      //自动充值列表
      let vm = this;
      let params = {};
      vm.$post("/app/user/rechargeDiscount", params, { loading: true }).then(
        res => {
          console.log("rechargeDiscount", res);
          vm.discountsList = res;
        }
      );
    }
  },
  watch: {
    money: {
      handler(obj) {
        console.log("money", obj);
        if (obj > Number(this.userInfo.money_usable)) {
          // 金额大于账户余额
          if (this.curPay.type == 3) {
            let list = [];
            for (let i = 0; i < this.payList.length; i++) {
              if (this.payList[i].type != 3) {
                list.push(this.payList[i]);
              }
            }
            this.curPay = list[0];
            this.curPayType = list[0].type;
          }
        }
        if (obj < Number(this.userInfo.money_usable) && this.payList.length) {
          // 金额小于账户余额且支付方式列表存在
          this.curPay = this.payList[0];
          this.curPayType = this.curPay.type;
        }
      },
      immediate: true
    },
    userInfo: {
      handler(obj) {
        if (obj.username) {
          this._getPayType();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.column {
  .title {
    .text-blue {
      text-decoration: underline;
    }
  }
  /deep/.van-radio {
    display: block;
    padding: 10px;
    border-top: 1.1px solid #e4e4e4;
    .van-radio__icon {
      float: right;
    }
    .van-radio__label {
      margin-left: 0;
      float: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      &.van-radio__label--disabled {
        span {
          color: #4a4a4a;
        }
        .text-gray {
          color: #999;
        }
      }
      .logoImg {
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .text-orange,
      .text-gray {
        margin-left: 10px;
        font-size: 12px;
      }
    }
  }
}
</style>
